import { type AxiosResponse } from 'axios';

import type IApiListResponse from '^types/api/IApiListResponse';
import type IStore from '^types/store/IStore';

import apiClient from '.';

export type TRequestStoresResponse = AxiosResponse<IApiListResponse<IStore>>;

export const requestStoresList = (): Promise<TRequestStoresResponse> => (
  apiClient.get('/Stores')
);
